// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2dxo9","legacyBtn":"MutateMid_legacyBtn__1vF90"};